import * as React from "react";
import {useForm} from "react-hook-form";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  SafeAreaView,
  FlatList,
  Linking,
  ScrollView,
  KeyboardAvoidingView,
} from "react-native";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import CommonModal from "../../../commonComponents/commonModal";
import Header from "../../../commonComponents/Header";
import DeleteBank from "../childComponents/deleteBank";
import BankChange from "../childComponents/newBankBottomsheet";
import {useSelector, connect, useDispatch} from "react-redux";
import {getBankDetails} from "../../Profile/redux/profile.action";
import {
  add_bank, international_redirect,
  kyc_pending,
  kyc_process,
  kyc_progress,
  successfulCall,
  usdt_currency,
} from "../../../utils/images";
import LottieComp from "../../../commonComponents/Lottie";
import {Network} from "../../../utils/network";
import WithdrawInfo from "./WithdrawInfo";
import {
  trackMoengageEvent,
  conversionMethod,
  isMobile,
  delayString, openURL,
} from "../../../utils/commonMethods";
import CryptoNetworkDetails from "../childComponents/CryptoNetworkDetails";
import {useEffect, useState} from "react";
import {getConversionData} from "../redux/wallet.action";
import {
  INDIA,
  PAYMENT_GATEWAY_AAA,
  REST_OF_WORLD,
} from "../../../utils/constants";
import FastImage from "../../../common/FastImage";
import {globalImport} from "../../../common/globalImports";
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import WalletAmountReview from "./WalletAmountReview";
import WalletTxnStatus from "../childComponents/WalletTxnStatus";
import WithdrawPaykassma from "./WithdrawPaykassma";
import {TEST_API} from "../../../utils/apiUrl";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import D24WithDrawBankDetails from "./D24WithDrawBankDetails";
import PaymentSelection from "../childComponents/PaymentGatewaySelection";
import {useFocusEffect} from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import LoginVerify from "../../Login/childComponents/LoginVerify";
import ChangeNumber from "../childComponents/ChangeNumber";
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import { Icon } from '@iconify/react';
import { ethers } from 'ethers';
import { magic, network, contractAddress, provider, getScwAddress, transferUSDT } from '../../../lib/magic';
import { FormProvider } from "react-hook-form";

const CryptoSelection = ({ onOptionSelect }) => {
    return (
        <View style={styles.container}>
            <View style={styles.optionsContainer}>
                <TouchableOpacity 
                    style={styles.optionItem}
                    onPress={() => onOptionSelect('bank')}
                >
                    <View style={styles.optionContent}>
                        <View style={styles.iconContainer}>
                            <Icon 
                                icon="solar:card-linear" 
                                width={32} 
                                height={32}
                                color={globalConfigurableData.primaryTextColor1}
                            />
                        </View>
                        <View style={styles.textContainer}>
                            <Text style={styles.optionTitle}>Convert to Crypto</Text>
                            <Text style={styles.optionDescription}>
                                Convert your TradeX credits to cryptocurrency
                            </Text>
                        </View>
                        <View style={styles.arrowContainer}>
                            <Icon 
                                icon="solar:alt-arrow-right-linear" 
                                width={24} 
                                height={24}
                                color={globalConfigurableData.secondaryTextColor1}
                            />
                        </View>
                    </View>
                </TouchableOpacity>

                <View style={styles.separator} />

                <TouchableOpacity 
                    style={styles.optionItem}
                    onPress={() => onOptionSelect('crypto')}
                >
                    <View style={styles.optionContent}>
                        <View style={styles.iconContainer}>
                            <Icon 
                                icon="solar:refresh-circle-linear" 
                                width={32} 
                                height={32}
                                color={globalConfigurableData.primaryTextColor1}
                            />
                        </View>
                        <View style={styles.textContainer}>
                            <Text style={styles.optionTitle}>Withdraw Crypto</Text>
                            <Text style={styles.optionDescription}>
                                Withdraw your cryptocurrency to external wallet
                            </Text>
                        </View>
                        <View style={styles.arrowContainer}>
                            <Icon 
                                icon="solar:alt-arrow-right-linear" 
                                width={24} 
                                height={24}
                                color={globalConfigurableData.secondaryTextColor1}
                            />
                        </View>
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const WithdrawMoney = ({
  navigation,
  getBankDetails,
  getConversionData,
  conversionData,
}) => {
  const ref = React.useRef(null);
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({mode: "onChange"});
  const dispatch = useDispatch();
  const [isShowDelete, setIsShowBankDelete] = React.useState(false);
  const [isShowBankAdd, setIsShowBankAdd] = React.useState(false);
  const [cryptoDetails, setCryptoDetails] = React.useState(null);

  const [showWithDrawConfirm, setShowWithDrawConfirm] = React.useState(false);
  const [enableReviewScreen, setEnableReviewScreen] = React.useState({
    reviewData: null,
  });
  const [enableStatusScreen, setEnableStatusScreen] = React.useState({
    paymentStatus: null,
  });
  const [showWalletSelection, setShowWalletSelection] = useState(false);
  const [paykasmaNumber, setPaykasmaNumber] = React.useState();
  const [showPaykassmaMob, setShowPaykassmaMob] = React.useState(false);

  let userInfo = useSelector(({profile}) => profile.profileData);
  const [paymentGateway, setPaymentGateway] = useState();

  const depositCurrencyIcon = paymentGateway?.currencyIcon;
  const isPaykasama = paymentGateway?.value?.includes("paykassma");
  const isMagicLink = paymentGateway?.value?.includes("magiclink");
  let currency = conversionData?.result?.from;

  const isProfileComplete = userInfo?.isProfileComplete;
  let coinsd = userInfo?.coinsd ? userInfo?.coinsd : 0;
  let maxWithdrawableAmount = userInfo?.maxWithdrawableAmount
    ? userInfo?.maxWithdrawableAmount
    : 0;

  let bankData = useSelector(({profile}) => profile?.BankDetailsData);
  const maxWithdrawableLimit = paymentGateway?.redeemRequestUpperLimit || 10000;
  const minWithdrawableLimit = paymentGateway?.redeemRequestLowerLimit || 100;
  const [conversionMessage, setConversationMessage] = React.useState("");
  const region = userInfo?.region_code;
  let bankAcc = useSelector(
    ({profile}) => profile?.BankDetailsData?.bankdetails,
  );

  const [selectedOption, setSelectedOption] = useState(null);
  const [headerTitle, setHeaderTitle] = useState('Withdraw');

  const [cryptoBalance, setCryptoBalance] = useState('');
  const [cryptoSymbol, setCryptoSymbol] = useState('');
  const [withdrawalAddress, setWithdrawalAddress] = useState('');
  const [isWithdrawing, setIsWithdrawing] = useState(false);
  const [withdrawalStatus, setWithdrawalStatus] = useState('');
  const [withdrawalAmount, setWithdrawalAmount] = useState('');

  const cryptoForm = useForm({
    mode: "onChange",
    defaultValues: {
      cryptoBalance: '',
      withdrawalAmount: '',
      withdrawalAddress: ''
    }
  });

  const [balanceInWei, setBalanceInWei] = useState('0');
  const [decimals, setDecimals] = useState(0);
  const MIN_AMOUNT = 1;

  useEffect(() => {
    if (selectedOption === 'crypto') {
      fetchCryptoBalance();
    }
  }, [selectedOption]);

  useEffect(() => {
    navigation.setOptions({
      headerLeft: () => (
        <TouchableOpacity 
          onPress={() => {
            if (selectedOption) {
              setSelectedOption(null);
            } else {
              navigation.goBack();
            }
          }}
        >
          <Icon 
            icon="solar:alt-arrow-left-linear" 
            width={24} 
            height={24}
            color={globalConfigurableData.primaryTextColor1}
          />
        </TouchableOpacity>
      ),
      headerTitle: selectedOption ? 
        (selectedOption === 'bank' ? 'Bank Withdrawal' : 'Convert to Crypto') : 
        'Withdraw'
    });
  }, [navigation, selectedOption]);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    if (option === 'bank') {
      setHeaderTitle(' Convert');
    } else if (option === 'crypto') {
      setHeaderTitle('Withdraw Crypto');
    }
  };

  useEffect(() => {
    setConversationMessage(conversionMethod(conversionData));
  }, [conversionData]);

  const paykassmaMob = globalImport.isWeb
    ? window.sessionStorage.getItem("paykassmaMobile")
    : paykasmaNumber;
  const wallet_address = isPaykasama
    ? paykassmaMob
      ? paykassmaMob
      : paymentGateway?.mobile
    : userInfo?.wallet_address;

  const amount = watch("amount");

  const walletAddress = watch("walletAddress");

  const onbankdelete = () => {
    setIsShowBankDelete(!isShowDelete);
  };

  useEffect(() => {
    if (wallet_address) {
      setValue("walletAddress", wallet_address);
    }
  }, [wallet_address]);

  const [respError, setResponseError] = React.useState({});
  const [error, setError] = React.useState();

  React.useEffect(() => {
    // getConversionData();
    getBankDetails();
    return () => {
      removePaymentGateway();
    };
  }, []);

  const removePaymentGateway = async () => {
    if (globalImport.isWeb) {
      window.sessionStorage.removeItem("pg");
      window.sessionStorage.removeItem("paykassmaMobile");
    } else {
      await AsyncStorage.removeItem("pg");
      await AsyncStorage.removeItem("paykassmaMobile");
    }
  };

  React.useEffect(() => {
    if (isProfileComplete === false && !isPaykasama) {
      const status = {
        isShow: true,
        status: false,
        msg: `Please complete your profile details first in order to deposit/withdraw funds`,
        amount: amount,
        profileVerified: isProfileComplete,
        buttonText: "Visit Profile Page",
      };
      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push("WalletStack", {
          screen: "WalletStatus",
          params: {paymentStatus: status},
        });
      }
    }
  }, [isProfileComplete]);

  const getPaymentGateway = async () => {
    if (!paymentGateway) {
      if (userInfo?.withdrawConfig?.pg?.length > 1 && isMobile()) {
        let pg;
        if (globalImport.isWeb) {
          pg = window.sessionStorage.getItem("pg");
        } else {
          pg = await AsyncStorage.getItem("pg");
        }
        if (pg) {
          setPaymentGateway(JSON.parse(pg));
        } else {
          setShowWalletSelection(true);
        }
      } else {
        setPaymentGateway(userInfo?.withdrawConfig?.pg?.[0]);
        if (region !== INDIA) {
          getConversionData({
            currency: userInfo?.withdrawConfig?.pg?.[0]?.currency,
          });
        }
      }
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      getPaymentGateway();
    }, [userInfo]),
  );

  useEffect(() => {
    if (isPaykasama && !paykassmaMob) {
      const isProfileComplete = userInfo?.isProfileComplete;
      if (isProfileComplete) {
        setShowPaykassmaMob(true);
      } else {
        navigation.navigate("Profile");
      }
    }
  }, [paymentGateway, userInfo]);

  const onFinalSubmit = () => {
    /*if (btnStatus?.btnText === "Add Bank Account") {
      setIsShowBankAdd(true);
    } else if (btnStatus?.btnText === "Proceed to KYC") {
      navigation.push("WalletStack", { screen: "Kyc" });
    } else*/
    if (isPaykasama) {
      if (!isProfileComplete) {
        redirectToKYC();
      } else {
        setCryptoDetails([
          {title: "Total credits to be withdrawn", value: amount},
          {
            title: "Amount to be withdrawn",
            value:
              (amount / conversionData?.result?.value).toFixed(2) + currency,
          },
          {title: "Account No", value: wallet_address},
          {
            title: "Payment Mode",
            value: paymentGateway?.value,
          },
        ]);
      }
    } else if (paymentGateway?.value === "direct24") {
      setCryptoDetails([
        {title: "Total credits to be withdrawn", value: amount},
        {
          title: "Amount to be withdrawn",
          value: (amount / conversionData?.result?.value).toFixed(2) + currency,
        },
      ]);
    } else if (btnStatus?.btnText === "Confirm Request" || btnStatus?.btnText === "Convert Credits to USDT") {
      putRedeemRequest();
    } else if (btnStatus?.btnText === "Processing...") {
    } else {
      if (!isMobile()) {
        setEnableReviewScreen({reviewData: 123, isCrypto: false});
      } else {
        navigation.navigate("WalletAmountReview", {
          amount: amount,
          confirmDepositClick: onPlaceOrderClick,
        });
      }

      //setShowWithDrawConfirm(true);
    }
  };

  const handleWithdrawalStatus = (isSuccess, data, amount) => {
    const status = {
      isShow: true,
      status: isSuccess,
      title: isSuccess ? "Withdraw Processing" : "Withdraw Failed",
      msg: data?.message,
      amount: amount,
      isCrypto: paymentGateway?.value === "magiclink",
      region: region
    };

    if (!isMobile()) {
      setEnableStatusScreen({paymentStatus: status});
    } else {
      navigation.push("WalletStack", {
        screen: "WalletStatus",
        params: {paymentStatus: status},
      });
    }
  };

  const putRedeemRequest = async () => {
    const res = await Network.redeemRequest(
      {
        amount: parseFloat(amount),
        walletAddress: walletAddress,
        pg: paymentGateway?.value,
      },
      true,
    );

    if (!res?.data?.success || res?.data?.error) {
      setError(true);
      setResponseError({
        val: res?.data?.message,
        class: {color: Colors.red},
        divClass: {borderColor: Colors.red, borderWidth: 2},
      });
      handleWithdrawalStatus(false, res?.data, amount);
    } else {
      setResponseError({
        val: res?.data?.message,
        class: {color: Colors.green},
        divClass: {borderColor: Colors.green, borderWidth: 2},
      });
      setError(false);
      handleWithdrawalStatus(true, res?.data, amount);
    }
  };

  const usdtApprox = delayString(amount, currency, conversionData);

  const confirmCryproPayout = async data => {
    setCryptoDetails(null);
    !isMobile() && setEnableReviewScreen(null);
    let res;
    if (isPaykasama || paymentGateway?.value === "direct24") {
      res = await Network.redeemRequest(
        {
          amount: parseFloat(amount),
          pg: paymentGateway?.value,
          mobile: wallet_address,
        },
        true,
      );
    } else {
      res = await Network.cryptoRedeemRequest(
        {
          payout_reference: data?.payout_reference,
        },
        true,
      );
    }
    if (!res?.data?.status || res?.data?.error) {
      const status = {
        isShow: true,
        status: false,
        msg: res?.data?.message,
        amount: amount,
        disclaimer: res?.data?.disclaimer,
      };
      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push("WalletStack", {
          screen: "WalletStatus",
          params: {paymentStatus: status},
        });
      }
    } else {
      const status = {
        isShow: true,
        status: true,
        msg: res?.data?.message,
        title: "Withdraw Processing",
        amount: amount,
        disclaimer: res?.data?.disclaimer,
      };
      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push("WalletStack", {
          screen: "WalletStatus",
          params: {paymentStatus: status},
        });
      }
    }
  };

  const onPlaceOrderClick = async (data, dispatch) => {
    !isMobile() && setEnableReviewScreen(null);
    if (btnStatus?.btnText === "Add Bank Account") {
      setIsShowBankAdd(true);
    } else if (btnStatus?.btnText === "Proceed to KYC") {
      navigation.push("WalletStack", {screen: "Kyc"});
    } else if (btnStatus?.btnText === "Processing...") {
      return;
    } else {
      if (showWithDrawConfirm) {
        setShowWithDrawConfirm(false);
      }

      const res = await Network.redeemRequest(
        {
          amount: parseFloat(amount),
          pg: paymentGateway?.value,
        },
        true,
      );
      if (!res?.data?.success || res?.data?.error) {
        trackMoengageEvent("Withdraw Status", {
          Status: "failed",
          Amount: parseFloat(data),
          Time: new Date(),
        });
        const status = {
          isShow: true,
          status: false,
          msg: res?.data?.message,
          amount: amount,
          disclaimer: res?.data?.disclaimer,
        };
        //setIsShowStatus();
        if (!isMobile()) {
          setEnableStatusScreen({paymentStatus: status});
        } else {
          navigation.push("WalletStack", {
            screen: "WalletStatus",
            params: {paymentStatus: status},
          });
        }
      } else {
        trackMoengageEvent("Withdraw Status", {
          Status: "Successfull",
          Amount: amount,
          Time: new Date(),
        });
        const status = {
          isShow: true,
          status: true,
          msg: res?.data?.message,
          title: "Withdraw Processing",
          amount: amount,
          disclaimer: res?.data?.disclaimer,
        };
        if (!isMobile()) {
          setEnableStatusScreen({paymentStatus: status});
        } else {
          navigation.push("WalletStack", {
            screen: "WalletStatus",
            params: {paymentStatus: status},
          });
        }
      }
    }
  };

  const InternationalElement = React.useCallback(() => {
    return (
      <View>
        <FormTextLabel
          labelStyles={{alignSelf: "flex-start", ...styles.withdrawErrTitle}}
          label={"Payment Details"}
        />
        <Text
          style={{
            width: 100,
            zIndex: 10,
            textAlign: "center",
            ...globalFontStyle.appFontSmallText10,
            color: Colors.black,
            position: "relative",
            backgroundColor: Colors.bgWhite,
            top: 10,
            left: 20,
          }}>
          {paymentGateway?.paymentdDetailAccount}
        </Text>
        <View style={[styles.inputDiv, respError ? respError?.divClass : null]}>
          <Input
            name="walletAddress"
            placeholder="eg: xgdyt"
            control={control}
            variant="outline"
            disabled={!!wallet_address}
            containerStyle={{marginBottom: 0}}
            fullWidth
            rules={{
              required: "Please enter a valid wallet address",
            }}
          />
          <View>
            {(isPaykasama ? userInfo?.mobile : userInfo?.wallet_address) ? (
              <FastImage
                style={{
                  height: 22,
                  width: 22,
                  marginRight: 10,
                  alignSelf: "flex-end",
                }}
                source={{uri: TEST_API + depositCurrencyIcon}}
              />
            ) : (
              <FastImage
                style={{
                  height: 22,
                  width: 22,
                  marginRight: 10,
                  alignSelf: "flex-end",
                }}
                source={usdt_currency()}
              />
            )}
          </View>
        </View>
        {errors?.walletAddress?.type === "required" && (
          <FormTextLabel
            labelStyles={globalStyle.errorText}
            label={errors?.walletAddress.message}
          />
        )}
        {error === true ? (
          <Text style={globalStyle.errorText}>{respError?.val}</Text>
        ) : (
          <Text style={styles.successText}>{respError?.val}</Text>
        )}
      </View>
    );
  }, [wallet_address, control, userInfo, respError]);

  const ChangeBankAcc = () => {
    return (
      <View style={styles.statusBlk}>
        <FastImage style={styles.noBankImg} source={add_bank()} />
        <View style={{flex: 1, justifyContent: 'flex-start'}}>
          <FormTextLabel
            labelStyles={styles.withdrawErrTitle}
            label={"No bank account found"}
          />
          <FormTextLabel
            labelStyles={styles.withdrawErrSubTitle}
            label={
              "Please add a bank account first in order to request a withdrawal"
            }
          />
          <TouchableOpacity onPress={redirectToKYC}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallTextBold,
                {
                  color: globalConfigurableData.primaryBtnColor,
                  textDecorationLine: "underline",
                  marginTop: 8,
                },
              ]}
              label={"Add Bank account"}
            />
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  const redirectToKYC = () => {
    if (!isProfileComplete) {
      navigation.navigate("Profile");
    } else {
      navigation.navigate("manageKycBank", {
        isD24: paymentGateway?.value === "direct24",
        showKYC: true
      });
    }
  };

  const KycInProgress = () => {
    return (
      <View style={styles.statusBlk}>
        <FastImage
          style={styles.noBankImg}
          source={add_bank()}
        />
        <View style={{flex: 1, justifyContent: 'flex-start'}}>
          <FormTextLabel
            labelStyles={styles.withdrawErrTitle}
            label={"KYC Under Review"}
          />
          <FormTextLabel
            labelStyles={styles.withdrawErrSubTitle}
            label={
              "Your KYC verification is under progress. Please wait for 48 working hours to get it processed."
            }
          />
        </View>
      </View>
    );
  };

  const KYCIncomplete = ({isProfile}) => {
    return (
      <View style={styles.statusBlk}>
        <FastImage
          style={styles.noBankImg}
          source={isProfile ? kyc_process() : add_bank()}
        />
        <View style={{flex: 1, justifyContent: 'flex-start'}}>
          <FormTextLabel
            labelStyles={styles.withdrawErrTitle}
            label={isProfile ? "Profile Incomplete" : "KYC Pending"}
          />
          <FormTextLabel
            labelStyles={styles.withdrawErrSubTitle}
            label={
              isProfile
                ? "Please complete your profile first in order to withdraw your funds."
                : "Please complete your KYC first in order to enjoy seamless trading experience."
            }
          />
          <TouchableOpacity onPress={redirectToKYC}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallTextBold,
                {
                  color: globalConfigurableData.primaryBtnColor,
                  textDecorationLine: "underline",
                  marginTop: 8,
                },
              ]}
              label={isProfile ? "Complete Profile" : "Complete KYC"}
            />
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  const onBottomSheetClose = () => {
    dispatch(getBankDetails());
    setIsShowBankAdd(false);
  };

  const getBtnStatus = () => {
    var status1;
    if (bankAcc) {
      status1 = {
        btnType: "btnBlack",
        btnText: "Withdraw Funds",
        isDisable: false,
      };
    } else if (
      paymentGateway?.value === "direct24" &&
      userInfo?.kycstatus === "C"
    ) {
      status1 = {
        btnType: "btnBlack",
        btnText: "Withdraw Funds",
        isDisable: false,
      };
    } else if (paymentGateway?.value === PAYMENT_GATEWAY_AAA || isPaykasama) {
      status1 = {
        btnType: "btnBlack",
        btnText: isProfileComplete ? "Confirm Request" : "Complete Profile",
        isDisable: false,
      };
    } else if (bankData?.errorCode === 413) {
      status1 = {
        btnType: "btnBlackInactive",
        btnText: "Processing...",
        isDisable: true,
      };
    } else if (userInfo?.kycstatus === "C" && paymentGateway?.value === "magiclink") {
      status1 = {
        btnType: "btnBlack",
        btnText: "Convert Credits to USDT",
        isDisable: false,
      };
    } else if (userInfo?.kycstatus === "C") {
      status1 = {
        btnType: "btnBlackInactive",
        btnText: "Proceed",
        isDisable: true,
      };
    } else {
      status1 = {
        btnType: "btnBlackInactive",
        btnText: "Proceed",
        isDisable: true,
      };
    }
    return status1;
  };

  let globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const guidelines = [
    " • *Actual rates may vary during the time of transaction.",
  ];

  const btnStatus = getBtnStatus();

  const getStartEnd = (str, sub) => [
    str.indexOf(sub),
    str.indexOf(sub) + sub.length - 1,
  ];

  const renderContent = () => {
    if (region === INDIA) {
      return renderBankWithdrawal();
    }

    if (!selectedOption) {
      return <CryptoSelection onOptionSelect={handleOptionSelect} />;
    }

    if (selectedOption === 'bank') {
      return renderBankWithdrawal();
    }

    if (selectedOption === 'crypto') {
      return renderCryptoWithdrawal();
    }
  };

  const renderBankWithdrawal = () => (
        <View style={{paddingTop: 10, flex: 1}}>
      {!enableReviewScreen?.reviewData && !enableStatusScreen?.paymentStatus ? (
            <View style={{flex: 1}}>
          <View style={{paddingHorizontal: 16, paddingTop: 10}}>
                {!isMobile() && userInfo?.withdrawConfig?.pg?.length > 1 && (
                  <PaymentSelection
                    pG={userInfo?.withdrawConfig?.pg}
                    onClick={() => setShowWalletSelection(false)}
                    setPaymentGateway={setPaymentGateway}
                    isWithdraw={true}
                  />
                )}
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSmallText,
                    {color: Colors.grey7},
                  ]}
                  label={"Credits to withdraw "}
                  rest={{conversionMessage: conversionMessage}}
                />
                <View
                  style={{
                    paddingTop: 10,
                    marginBottom: 10,
                  }}>
                  <Input
                    name="amount"
                    placeholder="Enter no. of credits"
                    control={control}
                    variant="default"
                    containerStyle={{marginBottom: 0}}
                    fullWidth
                    rules={
                      btnStatus?.btnText === "Proceed"
                        ? globalImport.isWeb
                          ? {}
                          : null
                        : {
                            required: "Please enter a valid amount",
                            min: minWithdrawableLimit,
                            max:
                              maxWithdrawableAmount.toFixed(2) >
                              maxWithdrawableLimit
                                ? maxWithdrawableLimit
                                : maxWithdrawableAmount.toFixed(2),
                          }
                    }
                    translate={true}
                  />
                  {region !== INDIA ? (
                    <Text
                      style={{
                        textAlign: "center",
                        position: "absolute",
                        right: 10,
                        top: 30,
                        color: Colors.tradexBlue,
                        ...globalFontStyle.appFontSmallText,
                      }}>
                      {usdtApprox}
                    </Text>
                  ) : null}
                  <Text
                    style={[
                      globalFontStyle.appFontSmallText,
                      {color: Colors.grey7, marginTop: 10},
                    ]}>
                    <FormTextLabel
                      labelStyles={[
                        globalFontStyle.appFontSmallText,
                        {color: Colors.grey7, marginTop: 10},
                      ]}
                      label={"Withdrawable Balance : "}
                    />
                    <Text style={{color: Colors.black}}>
                      {Math.floor(maxWithdrawableAmount)}
                    </Text>
                  </Text>
                </View>

                {errors?.amount?.type === "required" && (
                  <FormTextLabel
                    labelStyles={globalStyle.errorText}
                    label={errors?.amount.message}
                  />
                )}
                {(errors?.amount?.type === "min" ||
                  errors?.amount?.type === "max") && (
                  <Text style={globalStyle.errorText}>
                    {maxWithdrawableAmount > minWithdrawableLimit
                      ? `Withdrawal amount can be only between ${minWithdrawableLimit} and  ${
                          maxWithdrawableAmount > maxWithdrawableLimit
                            ? maxWithdrawableLimit
                            : maxWithdrawableAmount.toFixed(2)
                        }
             `
                      : "You need at least " +
                        minWithdrawableLimit +
                        " excluding rewards to withdraw the funds.You have insufficient funds"}
                  </Text>
                )}
              </View>

              <View
                style={{
                  paddingHorizontal: 16,
                  marginTop: 20,
                  flex: 1,
                }}>
                {!isProfileComplete ? (
                  <KYCIncomplete isProfile={true} />
                ) : paymentGateway?.value === PAYMENT_GATEWAY_AAA ||
                  isPaykasama || isMagicLink ? (
                  null
                ) : paymentGateway?.value === "direct24" &&
                  userInfo?.kycstatus === "C" ? (
                  <View>
                    <View>
                      <FormTextLabel
                        labelStyles={{
                          alignSelf: "flex-start",
                          ...styles.withdrawErrTitle,
                        }}
                        label={"Payment Details"}
                      />
                      <TouchableOpacity
                        onPress={onbankdelete}
                        style={{position: "absolute", right: 8}}>
                        <FormTextLabel
                          labelStyles={styles.changeText}
                          label={"Change"}
                        />
                      </TouchableOpacity>
                    </View>
                    <D24WithDrawBankDetails />
                  </View>
                ) : bankAcc ? (
                  <View>
                    <FormTextLabel
                      labelStyles={{
                        alignSelf: "flex-start",
                        ...styles.withdrawErrTitle,
                      }}
                      label={"Payment Details"}
                    />
                    <FormTextLabel
                      labelStyles={{
                        width: 100,
                        zIndex: 10,
                        textAlign: "center",
                        ...globalFontStyle.appFontSmallText10,
                        color: Colors.black,
                        position: "relative",
                        backgroundColor: Colors.bgWhite,
                        top: 10,
                        left: 20,
                      }}
                      label={"Registered Bank Details"}
                    />
                    <View style={[styles.inputDiv, {padding: 14}]}>
                      <FormTextLabel
                        label={"A/c No: "}
                        rest={{accountnumber: bankAcc?.accountnumber}}
                      />
                      <TouchableOpacity
                        onPress={onbankdelete}
                        style={{position: "absolute", right: 8}}>
                        <FormTextLabel
                          labelStyles={styles.changeText}
                          label={"Change"}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                ) : bankData?.errorCode === 413 ? (
                  <KycInProgress />
                ) : region === INDIA || paymentGateway?.isKycRequired ? (
                  userInfo?.kycstatus === "C" ? (
                    <ChangeBankAcc />
                  ) : (
                    <KYCIncomplete />
                  )
                ) : null}

                {userInfo?.kycstatus === "C" && region === "INDIA" && (
                  <View
                    style={{
                      marginBottom: isMobile() ? 100 : 15,
                      justifyContent: "flex-end",
                      flex: 1,
                    }}>
                    <View style={styles.infoBlk}>
                      <FormTextLabel
                        labelStyles={[
                          globalFontStyle.appFontSubText,
                          {color: Colors.lightgrey},
                        ]}
                        label={"Your KYC details has been linked to your PAN: "}
                        rest={{number: userInfo?.kycdetails?.number}}
                      />
                    </View>
                    <View style={styles.infoBlk}>
                      <Text
                        style={[
                          globalFontStyle.appFontSubText,
                          {color: Colors.lightgrey},
                        ]}>
                        {userInfo?.withdraw_disclaimer}
                      </Text>
                    </View>
                  </View>
                )}
              </View>
              {region !== INDIA && (
                <KeyboardAvoidingView
                  behavior={"height"}
                  style={{
                    marginTop: 20,
                    padding: 16,
                    marginBottom: isMobile() ? 100 : 15,
                  }}>
                  <FlatList
                    scrollEnabled
                    data={paymentGateway?.disclaimers}
                    contentContainerStyle={{
                      paddingHorizontal: 15,
                      paddingVertical: 10,
                      backgroundColor: "#F5F7F9",
                      borderRadius: 8,
                      marginBottom: 10,
                    }}
                    renderItem={({item, index: indexInitial}) => {
                      var index = [0, 0];
                      if (item?.linkText && item?.linkText !== null) {
                        index = getStartEnd(item.text, item.linkText);
                      }
                      return (
                        <Text
                          style={{
                            backgroundColor: "#F5F7F9",
                            borderRadius: 8,
                            marginBottom: 10,
                            ...globalFontStyle.appFontSubText,
                            color: Colors.lightgrey,
                          }}>
                      <Text style={{...globalFontStyle.appFontSubText}}>
                            {" • "}
                            {item.text.substring(0, index[0])}
                          </Text>
                          <Text
                            onPress={() => {
                              if (item?.link) {
                                Linking.openURL(item?.link);
                              }
                            }}
                            style={{
                              ...globalFontStyle.appFontSubText,
                          color: item?.link ? Colors.tradexBlue : Colors.black,
                            }}>
                            {item.text.substring(index[0], index[1] + 1)}
                          </Text>
                      <Text style={{...globalFontStyle.appFontSubText}}>
                        {item.text.substring(index[1] + 1, item.text.length)}
                          </Text>
                        </Text>
                      );
                    }}
                    keyExtractor={(item, index) => index}
                    showsVerticalScrollIndicator={false}
                  />
                  <FlatList
                    scrollEnabled
                    contentContainerStyle={{
                      paddingHorizontal: 15,
                      paddingVertical: 10,
                      backgroundColor: "#F5F7F9",
                      borderRadius: 8,
                    }}
                    data={guidelines}
                renderItem={({item, index}) => (
                        <FormTextLabel
                          labelStyles={{
                            ...globalFontStyle.appFontSubText,
                            color: Colors.lightgrey,
                            paddingVertical: 5,
                          }}
                          label={item}
                        />
                )}
                    keyExtractor={(item, index) => index}
                    showsVerticalScrollIndicator={false}
                    initialNumToRender={10}
                  />
                </KeyboardAvoidingView>
              )}
              <View
                style={[
                  isMobile()
                    ? globalStyle.bottomAbsBtnBar
                    : {
                        paddingHorizontal: 16,
                        paddingVertical: 13,
                        flexDirection: "row",
                        backgroundColor: Colors.bgWhite,
                        justifyContent: "space-between",
                      },
                  {
                    width:
                      ref?.current?.offsetWidth ||
                      (isMobile() ? Width.width : 250),
                  },
                ]}>
                <Button
                  variant={btnStatus.btnType === "btnBlack" ? "primary" : "disabled"}
                  onPress={handleSubmit(onFinalSubmit)}
                  style={{flex: 1, marginTop: 15}}
                  disabled={btnStatus.isDisable}
                  translate={true}
                >
                  {btnStatus.btnText}
                </Button>
              </View>
            </View>
          ) : !enableStatusScreen?.paymentStatus ? (
            <WalletAmountReview
              rechargeDetails={enableReviewScreen.reviewData}
              setEnableReviewScreen={setEnableReviewScreen}
              confirmDepositClick={
                enableReviewScreen?.isCrypto
                  ? confirmCryproPayout
                  : onPlaceOrderClick
              }
              isCryptoPayout={enableReviewScreen?.isCrypto}
              amount={amount}
            />
          ) : (
            <WalletTxnStatus
              paymentStatus1={enableStatusScreen?.paymentStatus}
              setStatus={setEnableStatusScreen}
              navigation={navigation}
            />
          )}
        </View>
  );

  const fetchCryptoBalance = async () => {
    try {
      const address = await getScwAddress(network);
      console.log("WITHDRAW ADDRESS", address);
      const provider = new ethers.JsonRpcProvider(network.rpcUrl);
      const abi = [
        "function balanceOf(address owner) view returns (uint256)",
        "function decimals() view returns (uint8)",
        "function symbol() view returns (string)"
      ];
      const contract = new ethers.Contract(contractAddress, abi, provider);

      const [balance, decimals, symbol] = await Promise.all([
        contract.balanceOf(address),
        contract.decimals(),
        contract.symbol()
      ]);

      const formattedBalance = ethers.formatUnits(balance, decimals);
      setCryptoBalance(formattedBalance);
      setBalanceInWei(balance.toString());
      setDecimals(decimals);
      setCryptoSymbol(symbol);
      
      // Update the form values
      cryptoForm.setValue('cryptoBalance', `${formattedBalance} ${symbol}`);
    } catch (error) {
      console.error("Error fetching crypto balance:", error);
      setCryptoBalance('0');
      setBalanceInWei('0');
      setDecimals(18); // Default for most ERC20 tokens
      setCryptoSymbol('USDT');
      cryptoForm.setValue('cryptoBalance', '0 USDT');
    }
  };

  const isValidAmount = (value) => {
    if (!value) return false;
    const amount = parseFloat(value);
    if (isNaN(amount)) return false;
    
    try {
        const amountInWei = ethers.parseUnits(value, decimals).toString();
        return amount >= MIN_AMOUNT && BigInt(amountInWei) <= BigInt(balanceInWei);
    } catch (error) {
        return false;
    }
  };

  const handleCryptoWithdraw = async () => {
    if (!withdrawalAddress || !withdrawalAmount || !cryptoBalance) return;

    if (!isValidAmount(withdrawalAmount)) {
      const status = {
        isShow: true,
        status: false,
        title: 'Invalid Amount',
        msg: 'Please enter a valid withdrawal amount',
      };
      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push('WalletStack', {
          screen: 'WalletStatus',
          params: {paymentStatus: status}
        });
      }
      return;
    }

    try {
      setIsWithdrawing(true);
      setWithdrawalStatus('Initiating withdrawal...');

      // Get signer from Magic SDK
      // const signer = await provider.getSigner();
      // const amountInWei = ethers.parseUnits(withdrawalAmount, decimals).toString();

      // // Create transaction
      // const tx = {
      //   to: contractAddress,
      //   value: 0,
      //   data: new ethers.Interface([
      //     "function transfer(address to, uint256 amount) returns (bool)"
      //   ]).encodeFunctionData("transfer", [withdrawalAddress, amountInWei])
      // };

      setWithdrawalStatus('Please confirm the transaction in your wallet...');
      // const transactionResponse = await signer.sendTransaction(tx);
      const transactionResponse = await transferUSDT(withdrawalAddress, withdrawalAmount);

      setWithdrawalStatus('Awaiting block confirmation...');
      // await transactionResponse.wait();
      console.log('transactionResponse', transactionResponse);
      setWithdrawalStatus('Processing withdrawal request...');
      // const payload = {
      //   amount: withdrawalAmount,
      //   pg: 'magiclink',
      //   walletAddress: withdrawalAddress,
      //   currency: 'USDT',
      //   txHash: transactionResponse.hash
      // };

      // console.log('Sending payload:', payload);
      // const res = await Network.redeemRequest(payload, true);
      // console.log('Backend response:', res?.data);

      if (true) {
        const status = {
          isShow: true,
          status: true,
          title: "Withdraw Processing",
          msg: res?.data?.message || `Your withdrawal of ${withdrawalAmount} ${cryptoSymbol} has been processed against transaction ID ${transactionResponse.hash}`,
          amount: withdrawalAmount,
          currency: cryptoSymbol,
          walletAddress: withdrawalAddress,
          transactionId: transactionResponse.hash
        };
        
        if (!isMobile()) {
          setEnableStatusScreen({paymentStatus: status});
        } else {
          navigation.push('WalletStack', {
            screen: 'WalletStatus',
            params: {paymentStatus: status}
          });
        }

        // Refresh balance after successful withdrawal
        fetchCryptoBalance();
      } else {
        throw new Error(res?.data?.msg || 'Withdrawal failed');
      }
    } catch (error) {
      console.error('Withdrawal error:', error);
      const status = {
        isShow: true,
        status: false,
        title: "Withdraw Failed",
        msg: error.message || res?.data?.message || 'Failed to process withdrawal. Please try again.',
        amount: withdrawalAmount,
        currency: cryptoSymbol
      };

      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push('WalletStack', {
          screen: 'WalletStatus',
          params: {paymentStatus: status}
        });
      }
    } finally {
      setIsWithdrawing(false);
      setWithdrawalStatus('');
    }
  };

  const renderCryptoWithdrawal = () => {
    return (
      <FormProvider {...cryptoForm}>
        <View style={styles.contentContainer}>
          <View style={styles.balanceSection}>
            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {color: Colors.grey7, marginBottom: 8}
              ]}
              label="Available Balance"
            />
            <View style={styles.balanceContainer}>
              <Input
                name="cryptoBalance"
                value={`${cryptoBalance} ${cryptoSymbol}`}
                disabled
                control={cryptoForm.control}
                variant="default"
                style={{backgroundColor: Colors.lightgrey1}}
                inputStyle={{backgroundColor: Colors.lightgrey1}}
                containerStyle={{marginBottom: 24}}
              />
            </View>

            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {color: Colors.grey7, marginBottom: 8}
              ]}
              label="Select Chain"
            />
            <Input
              name="chain"
              value="Polygon Network"
              disabled
              control={cryptoForm.control}
              variant="default"
              style={{backgroundColor: Colors.lightgrey1}}
              inputStyle={{backgroundColor: Colors.lightgrey1}}
              containerStyle={{marginBottom: 24}}
              startAdornment={
                <Icon 
                  icon="logos:polygon-matic" 
                  width={24} 
                  height={24}
                  style={{marginRight: 8}}
                />
              }
            />

            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {color: Colors.grey7, marginBottom: 8}
              ]}
              label="Amount to Withdraw"
            />
            <Input
              name="withdrawalAmount"
              placeholder={`Enter amount in ${cryptoSymbol}`}
              control={cryptoForm.control}
              variant="default"
              containerStyle={{marginBottom: 24}}
              keyboardType="numeric"
              fullWidth
              hide={false}
              onChangeText={(text) => {
                // Remove any non-numeric characters except decimal point
                const sanitizedText = text.replace(/[^0-9.]/g, '');
                // Ensure only one decimal point
                const parts = sanitizedText.split('.');
                const finalText = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');
                setWithdrawalAmount(finalText);
                cryptoForm.setValue('withdrawalAmount', finalText, { shouldValidate: true });
              }}
              
              
              rules={{
                required: "Please enter withdrawal amount",
                validate: value => {
                  if (!value) return "Amount is required";
                  if (!isValidAmount(value)) {
                    const numericValue = parseFloat(value);
                    if (isNaN(numericValue)) return "Please enter a valid number";
                    if (numericValue < MIN_AMOUNT) return `Amount must be greater than ${MIN_AMOUNT}`;
                    return "Amount exceeds available balance";
                  }
                  return true;
                }
              }}
            />

            <FormTextLabel
              labelStyles={[
                globalFontStyle.appFontSmallText,
                {color: Colors.grey7, marginBottom: 8}
              ]}
              label="Withdrawal Address"
            />
            <Input
              name="withdrawalAddress"
              placeholder="Enter your crypto wallet address"
              control={cryptoForm.control}
              variant="default"
              containerStyle={{marginBottom: 16}}
              fullWidth
              hide={false}
              onChangeText={(text) => {
                // Remove spaces from wallet address
                const sanitizedText = text.trim();
                setWithdrawalAddress(sanitizedText);
                cryptoForm.setValue('withdrawalAddress', sanitizedText, { shouldValidate: true });
              }}
              rules={{
                required: "Wallet address is required",
                validate: value => {
                  if (!value) return "Wallet address is required";
                  // Basic Ethereum address validation (0x followed by 40 hex characters)
                  const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
                  if (!ethAddressRegex.test(value)) {
                    return "Please enter a valid Ethereum wallet address";
                  }
                  return true;
                }
              }}
            />

            <View style={styles.disclaimerContainer}>
              <Text style={styles.disclaimerText}>
                • Please ensure you enter the correct wallet address. Incorrect addresses may result in permanent loss of funds.
              </Text>
              <Text style={styles.disclaimerText}>
                • Withdrawable balance updates every 2 hours.
              </Text>
            </View>

            {isWithdrawing && withdrawalStatus && (
              <View style={styles.statusContainer}>
                <Text style={styles.statusText}>{withdrawalStatus}</Text>
              </View>
            )}
          </View>

          <View style={[
            styles.buttonContainer,
            isMobile() ? styles.mobileButtonContainer : styles.webButtonContainer
          ]}>
            <Button
              variant="primary"
              onPress={cryptoForm.handleSubmit(handleCryptoWithdraw)}
              style={styles.submitButton}
              disabled={!withdrawalAddress || !withdrawalAmount || isWithdrawing}
              loading={isWithdrawing}
            >
              Proceed to Withdraw
            </Button>
          </View>
        </View>
      </FormProvider>
    );
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]} ref={ref}>
      <ScrollView
        style={{backgroundColor: "#ffffff", flexGrow: 1}}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{flexGrow: 1}}
        automaticallyAdjustKeyboardInsets={true}>
        <CommonModal
          onModalCallBack={onbankdelete}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
          ]}
          showModal={isShowDelete}>
          <DeleteBank
            paymentGateway={paymentGateway}
            onbankdelete={() => {
              setTimeout(() => {
                onbankdelete();
              }, globalConfigData?.buttonTimer);
            }}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {}}
          showModal={showWalletSelection}
          customModalStyle={[globalStyle.modalView, {alignItems: "stretch"}]}
          persistent={true}>
          <PaymentSelection
            pG={userInfo?.withdrawConfig?.pg}
            onClick={() => setShowWalletSelection(false)}
            setPaymentGateway={setPaymentGateway}
            isWithdraw={true}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            navigation.pop();
          }}
          showModal={showPaykassmaMob}
          customModalStyle={[
            isMobile()
              ? {...globalStyle.modalView, alignItems: "stretch"}
              : globalStyle.modalStyleCenter,
          ]}
          persistent={true}>
          <>
            {!paymentGateway?.mobile ? (
              <LoginVerify
                mobVerfiedCallback={val => {
                  if (val) {
                    setPaykasmaNumber(val);
                  }
                  setShowPaykassmaMob(false);
                }}
              />
            ) : (
              <ChangeNumber
                mobVerfiedCallback={val => {
                  if (val) {
                    setPaykasmaNumber(val);
                  }
                  setShowPaykassmaMob(false);
                }}
                mob={paymentGateway?.mobile}
              />
            )}
          </>
        </CommonModal>
        {isMobile() && (
          <Header
            isInternalPage={false}
            navigation={navigation}
            pageName={headerTitle}
            backGroundColor={"#FFFFFF"}
            translate={true}
          />
        )}
        
        {renderContent()}

        <CommonModal
          onModalCallBack={() => {
            setIsShowBankAdd(false);
          }}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
          ]}
          showModal={isShowBankAdd}>
          <BankChange initiateBottomSheetClose={onBottomSheetClose} />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            setCryptoDetails(null);
          }}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
            {paddingTop: 20, alignItems: "stretch"},
          ]}
          showModal={cryptoDetails !== null}>
          {isPaykasama || paymentGateway?.value === "direct24" ? (
            <WithdrawPaykassma
              details={cryptoDetails}
              withDrawConfirmBtnClick={confirmCryproPayout}
            />
          ) : (
            <CryptoNetworkDetails
              details={cryptoDetails}
              withDrawConfirmBtnClick={confirmCryproPayout}
            />
          )}
        </CommonModal>
      </ScrollView>
    </SafeAreaView>
  );
};

const mapStateToProps = ({profile, wallet}) => ({
  BankDetailsData: profile.BankDetailsData,
  conversionData: wallet.conversionData,
});

const mapDispatchToProps = {
  getBankDetails,
  getConversionData,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawMoney);

const styles = StyleSheet.create({
  moneyTapContainer: {
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderWidth: 0.2,
    borderRadius: 20,
    marginRight: 14,
  },
  registerBankText: {
    ...globalFontStyle.appFontSmallTextBold,
    color: Colors.grey2,
  },
  accountNumText: {
    ...globalFontStyle.appFontBody,
    color: Colors.black,
  },
  kycStatusText: {
    ...globalFontStyle.appFontSmallText10,
    color: Colors.tradexBlue,
    textAlign: "center",
    marginTop: 68,
  },
  inputDiv: {
    flexDirection: "row",
    marginBottom: 10,
    paddingLeft: 0,
    borderRadius: 8,
    alignItems: "center",
    borderColor: Colors.borderColor,
    borderWidth: 1,
  },
  bankChargeInfo: {
    ...globalFontStyle.appSmall10,
    color: Colors.black1,
    textAlign: "center",
    marginTop: 7,
  },
  changeText: {
    ...globalFontStyle.appFontSubTextBold,
    color: Colors.tradexBlue,
  },
  noBankImg: {
    width: 24,
    height: 24,
    marginRight: 12,
    marginTop: 2,
  },
  withdrawErrTitle: {
    ...globalFontStyle.appFontSubTextBold,
    color: Colors.black,
    flex: 1,
    marginTop: -2,
  },
  withdrawErrSubTitle: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.secondaryTextColor1,
    marginTop: 6,
  },
  successText: {
    ...globalFontStyle.appFontSmallText,
    color: "#00aa51",
  },

  infoBlk: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: "#F5F7F9",
    borderRadius: 8,
    marginBottom: 10,
  },
  statusBlk: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#FFDC5D",
    backgroundColor: "rgba(255, 220, 93, 0.1)",
    flexDirection: "row",
    alignItems: "flex-start",
  },
  labelSS: {
    width: 100,
    zIndex: 10,
    textAlign: "center",
    ...globalFontStyle.appFontSmallText10,
    color: Colors.black,
    position: "relative",
    backgroundColor: Colors.bgWhite,
    top: 10,
    left: 20,
  },
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  optionsContainer: {
  },
  optionItem: {
    paddingVertical: 20,
    paddingHorizontal: 16,
  },
  optionContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    width: 56,
    height: 56,
    borderRadius: 28,
    borderWidth: 4,
    borderColor: globalConfigurableData.primaryBtnColor,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    marginLeft: 16,
    flex: 1,
  },
  arrowContainer: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  optionTitle: {
    ...globalFontStyle.appFontHeading,
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 3,
  },
  optionDescription: {
    ...globalFontStyle.appFontSubText,
    lineHeight: 18,
    color: globalConfigurableData.secondaryTextColor1,
  },
  separator: {
    height: 1,
    backgroundColor: '#EEEEEE',
  },
  contentContainer: {
    flex: 1,
    padding: 16,
  },
  balanceSection: {
    flex: 1,
  },
  balanceContainer: {
    marginBottom: 24,
  },
  disclaimerContainer: {
    backgroundColor: '#F5F7F9',
    padding: 16,
    borderRadius: 8,
    marginTop: 24,
  },
  disclaimerText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.grey7,
    marginBottom: 8,
  },
  buttonContainer: {
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    backgroundColor: Colors.bgWhite,
  },
  mobileButtonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    ...globalStyle.bottomAbsBtnBar
  },
  webButtonContainer: {
    marginTop: 'auto',
  },
  submitButton: {
    width: '100%',
  },
  statusContainer: {
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 16,
  },
  statusText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.primaryTextColor1,
  },
});
